var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11028_4542)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.08333 15.8307H2.08333C0.934167 15.8307 0 14.8957 0 13.7474V3.7474C0 2.59906 0.934167 1.66406 2.08333 1.66406H14.5833C15.7325 1.66406 16.6667 2.59906 16.6667 3.7474V7.08073C16.6667 7.31156 16.48 7.4974 16.25 7.4974C16.02 7.4974 15.8333 7.31156 15.8333 7.08073V3.7474C15.8333 3.05823 15.2725 2.4974 14.5833 2.4974H2.08333C1.39417 2.4974 0.833333 3.05823 0.833333 3.7474V13.7474C0.833333 14.4366 1.39417 14.9974 2.08333 14.9974H7.08333C7.31333 14.9974 7.5 15.1841 7.5 15.4141C7.5 15.6441 7.31333 15.8307 7.08333 15.8307Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 5.83333H0.416667C0.186667 5.83333 0 5.64667 0 5.41667C0 5.18667 0.186667 5 0.416667 5H16.25C16.48 5 16.6667 5.18667 16.6667 5.41667C16.6667 5.64667 16.48 5.83333 16.25 5.83333Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7487 4.16667C3.5187 4.16667 3.33203 3.98 3.33203 3.75V0.416667C3.33203 0.186667 3.5187 0 3.7487 0C3.9787 0 4.16536 0.186667 4.16536 0.416667V3.75C4.16536 3.98 3.9787 4.16667 3.7487 4.16667Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 4.16667C12.6867 4.16667 12.5 3.98 12.5 3.75V0.416667C12.5 0.186667 12.6867 0 12.9167 0C13.1467 0 13.3333 0.186667 13.3333 0.416667V3.75C13.3333 3.98 13.1467 4.16667 12.9167 4.16667Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5846 19.9974C11.598 19.9974 9.16797 17.5674 9.16797 14.5807C9.16797 11.5941 11.598 9.16406 14.5846 9.16406C17.5713 9.16406 20.0013 11.5941 20.0013 14.5807C20.0013 17.5674 17.5713 19.9974 14.5846 19.9974ZM14.5846 9.9974C12.058 9.9974 10.0013 12.0532 10.0013 14.5807C10.0013 17.1082 12.058 19.1641 14.5846 19.1641C17.1113 19.1641 19.168 17.1082 19.168 14.5807C19.168 12.0532 17.1113 9.9974 14.5846 9.9974Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5846 17.4974C14.3546 17.4974 14.168 17.3107 14.168 17.0807V12.0807C14.168 11.8507 14.3546 11.6641 14.5846 11.6641C14.8146 11.6641 15.0013 11.8507 15.0013 12.0807V17.0807C15.0013 17.3107 14.8146 17.4974 14.5846 17.4974Z",
    fill: "#383838"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0846 14.9974H12.0846C11.8546 14.9974 11.668 14.8107 11.668 14.5807C11.668 14.3507 11.8546 14.1641 12.0846 14.1641H17.0846C17.3146 14.1641 17.5013 14.3507 17.5013 14.5807C17.5013 14.8107 17.3146 14.9974 17.0846 14.9974Z",
    fill: "#383838"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11028_4542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcn);
export default __webpack_public_path__ + "static/media/calendarIcn.06ad897e6cfa3670aecd0bd66e87c1cc.svg";
export { ForwardRef as ReactComponent };